import { pick } from 'lodash';

export const Product = {
  YUNCHA: 1,
  RETAIL: 2,
  BRAND: 3,
  RHINO: 4,
  GUIDER: 5,
  DASHBOARD: 6,
};

export const ProductIdList = Object.values(Product);

export const ProductText = {
  [Product.YUNCHA]: '云察',
  [Product.RETAIL]: '零售小程序',
  [Product.BRAND]: '品牌小程序',
  [Product.RHINO]: '巨犀',
  [Product.GUIDER]: '导购',
  [Product.DASHBOARD]: '全域面板',
};

export function updateProductText(productText) {
  Object.assign(ProductText, productText);
}

export const DataPerm = {
  MCH: 'MERCHANT',
  STORE: 'STORE',
};

export const DataPermText = {
  [DataPerm.MCH]: '商户',
  [DataPerm.STORE]: '门店',
  [DataPerm.AREA]: '地区',
};

export const DataPermByProduct = {
  [Product.YUNCHA]: pick(DataPerm, ['MCH', 'STORE', 'AREA']),
  [Product.GUIDER]: pick(DataPerm, ['MCH', 'STORE', 'AREA']),
  [Product.RETAIL]: pick(DataPerm, ['MCH', 'STORE']),
  [Product.BRAND]: pick(DataPerm, ['MCH', 'STORE']),
};
